import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const USER_ME = 'USER_ME';
export const USER_ME_SUCCESS = 'USER_ME_SUCCESS';
export const USER_ME_FAILURE = 'USER_ME_FAILURE';

// Action Creators
export const fetchUserMe = () => ({
  type: USER_ME,
});

export const fetchUserMeSuccess = (data) => ({
  type: USER_ME_SUCCESS,
  payload: data,
});

export const fetchUserMeFailure = (error) => ({
  type: USER_ME_FAILURE,
  payload: error,
});

// Thunk Function
export const userMeCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUserMe(data, external));
    try {
      const response = await getMethodWithToken(url.userMeApi);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUserMeSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUserMeFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUserMeFailure(error.message));
    }
  };
};
